<template>
  <v-app v-cloak class="justify-center">
    <div v-if="backgroundImageUrl && isWebkit && $vuetify.breakpoint.mdAndDown" style="position: sticky; top: 0px; width: 100%">
      <div class="background-image-container">
        <img class="background-image" v-bind:src="backgroundImageUrl" />
      </div>
    </div>

    <div v-if="(backgroundImageUrl && !isWebkit) || (isWebkit && $vuetify.breakpoint.mdAndUp)" style="position: sticky; top: 0px; width: 100%">
      <div class="background-image-container" :style="{ backgroundImage: !isWebkit || !$vuetify.breakpoint.mdAndDown ? backgroundImageHelper(backgroundImageUrl) : 'none' }"></div>
    </div>
    <main-header />

    <v-main>
      <overlay-request-card-reminder-modal :redirect-link="cardApplyRedirectLink" />
      <subscription-warning-modal />
      <payment-gateway-offline-modal />
      <restricted-to-members-modal />

      <hello-uncaught-error-modal />

      <div class="page-container">
        <router-view />
      </div>
    </v-main>

    <h-footer v-if="!hideFooter" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { backgroundImageHelper } from '@/composables/image-helper';
import MainHeader from '@/components/navbars/MainHeader';
import OverlayRequestCardReminderModal from './components/overlays/components/OverlayRequestCardReminderModal.vue';
import SubscriptionWarningModal from './components/subscription/SubscriptionWarningModal.vue';
import RestrictedToMembersModal from '@/components/subscription/RestrictedToMembersModal.vue';
import PaymentGatewayOfflineModal from '@/components/modals/PaymentGatewayOfflineModal.vue';
import { convertColorToRgb } from '@/utils/color/color-helper';

export default {
  name: 'app',
  setup(props, { root }) {
    const UA = navigator.userAgent;
    const isWebkit = /\b(iPad|iPhone|iPod)\b/.test(UA) && /WebKit/.test(UA) && !/Edge/.test(UA) && !window.MSStream;

    for (let color in root.$vuetify.theme.themes.light) {
      const { rgbString } = convertColorToRgb(root.$vuetify.theme.themes.light[color]);
      document.documentElement.style.setProperty(`--color-${color}-rgb-values`, rgbString);
    }

    return {
      backgroundImageHelper,
      isWebkit,
    };
  },
  components: {
    PaymentGatewayOfflineModal,
    RestrictedToMembersModal,
    MainHeader,
    OverlayRequestCardReminderModal,
    SubscriptionWarningModal,
  },
  computed: {
    ...mapGetters('space', ['backgroundImageUrl', 'brandingColor']),
    cardApplyRedirectLink() {
      return {
        url: window.location.href,
        label_fr: this.$t('components.card_application.redirect_link.return_to_home_label', 'fr'),
        label_en: this.$t('components.card_application.redirect_link.return_to_home_label', 'en'),
      };
    },
    hideFooter() {
      return this.$route.meta.hideFooter || false;
    },
    fullscreenContent() {
      return this.$route.meta.fullscreen;
    },
    backgroundContent() {
      return this.$route.meta.backgroundColor;
    },
    maxContent() {
      return this.$route.meta.maxContent;
    },
    maxPage() {
      return this.$route.meta.maxPage;
    },
  },
  watch: {
    backgroundContent: {
      handler() {
        if (this.$route.meta.backgroundColor) {
          document.documentElement.style.setProperty('--color-background-alt', this.$route.meta.backgroundColor);
        } else {
          document.documentElement.style.setProperty('--color-background-alt', 'rgba(244, 244, 244, 1)');
        }
      },
      immediate: true,
    },
    maxContent: {
      handler() {
        if (this.$route.meta.maxContent) {
          document.documentElement.style.setProperty('--page-content-max-width', this.maxContent);
        } else {
          document.documentElement.style.setProperty('--page-content-max-width', '1200px');
        }
      },
      immediate: true,
    },
    fullscreenContent: {
      handler() {
        if (this.$route.meta.fullscreen) {
          document.documentElement.style.setProperty('--page-content-max-width', '100%');
        } else {
          document.documentElement.style.setProperty('--page-content-max-width', this.maxContent || '1200px');
        }
      },
      immediate: true,
    },
    maxPage: {
      handler() {
        if (this.$route.meta.maxPage) {
          document.documentElement.style.setProperty('--page-max-width', this.maxPage);
        } else {
          document.documentElement.style.setProperty('--page-max-width', '1200px');
        }
      },
      immediate: true,
    },
    brandingColor: {
      handler() {
        const { hex, rgbString } = convertColorToRgb(this.brandingColor);

        document.documentElement.style.setProperty('--color-branding', hex);
        document.documentElement.style.setProperty('--color-branding-rgb-values', rgbString);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.background-image-container {
  position: absolute;
  top: 0px;
  height: 110vh;
  width: 100%;
  overflow-y: hidden;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.background-image {
  height: 100vh;
  width: auto;
  min-width: 100vw;
  translate: calc(-50% + 50vw);
}
.page-container {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-bottom: 20px;
  height: 100%;
}
</style>
